import styled from '@emotion/styled'

import { colors } from '../../__styling/settings/colors'
import { fonts } from '../../__styling/settings/fonts'
import { metrics } from '../../__styling/settings/metrics'
import { easing } from '../../__styling/settings/easing'
import { calcRem } from '../../__styling/style-functions/calc-rem'

import { WebLink } from '@news-mono/web-common'
import { IconEmail } from '../../icons/IconEmail/IconEmail'
import { themedValue } from '../../__styling/themed-value'

export const StyledProfileEmailButton = styled(WebLink)(
    {
        color: colors.white,
        borderRadius: '2px',
        border: 0,
        fontSize: calcRem(12),
        fontWeight: 600,
        lineHeight: 1,
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        transition: `all ${easing.easeOut.fast}`,
    },
    ({ theme }) =>
        theme.kind === 'perthnow' && {
            alignSelf: 'flex-start',
            lineHeight: 1.25,

            '&:hover': {
                borderColor: colors.social.email,
                color: colors.social.email,
            },

            '&:focus, &:active': {
                outline: 'none',
                backgroundColor: colors.perthnow.greyBasalt,
                color: colors.perthnow.greyBasalt,
            },
        },
    ({ theme }) => ({
        padding: themedValue(theme, {
            fallback: `${calcRem(metrics.thewest.margins.xs)} ${calcRem(6)}`,
            perthnow: `${calcRem(2)} ${calcRem(6)}`,
        }),
        background: themedValue(theme, {
            thewest: (section) => section.primaryColor,
            perthnow: colors.social.email,
            fallback: colors.thewest.westblue,
        }),
        fontFamily: themedValue(theme, {
            fallback: fonts.thewest.sansSerif,
            perthnow: fonts.perthnow.sansSerif,
        }),
        '&:hover, &:focus': {
            background: themedValue(theme, {
                fallback: colors.thewest.greyGorilla,
                perthnow: colors.white,
            }),
        },
    }),
)

export const StyledIconEmail = styled(IconEmail)(
    {
        fill: 'currentColor',
    },
    ({ theme }) => ({
        width: calcRem(12),
        height: themedValue(theme, {
            fallback: calcRem(8),
            perthnow: calcRem(11),
        }),
        marginRight: themedValue(theme, {
            fallback: calcRem(metrics.thewest.margins.xs),
            perthnow: calcRem(metrics.perthnow.margins.xs),
        }),
    }),
)
